import { defineComponent as _defineComponent } from 'vue'
import { MonetizationType } from '@/@types/graphql-types';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeV2',
  props: {
    title: null,
    offers: null,
    seasonNumber: null,
    availableMonetizationTypes: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
	availableMonetizationTypes: Set<MonetizationType>;
};



const { getOfferTextBlock } = useSpinningText(toRefs(props));

// using getOfferTextBlock so we get the filtering, unique offers and joining
const provider = getOfferTextBlock(MonetizationType.Free, '', '');

const freeOffers = computed(() => props.offers.filter(offer => offer.monetizationType === MonetizationType.Free));

return { __sfc: true,props, getOfferTextBlock, provider, freeOffers, MonetizationType }
}

})